export default {"src":"/_next/static/media/broken-file.806f3266.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};